import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notification_tile = _resolveComponent("notification-tile")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_skeleton_notification = _resolveComponent("skeleton-notification")
  const _component_scrollable_wrapper = _resolveComponent("scrollable-wrapper")

  return (_openBlock(), _createBlock(_component_scrollable_wrapper, {
    "scroll-direction": $options.scrollDirection,
    class: _normalizeClass($options.scrollClassList)
  }, {
    default: _withCtx(() => [
      (_ctx.isInitialized)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['_flex _fd-c--l', $options.wrapperClassList]),
            role: "list"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedNotifications, (notification, index) => {
              return (_openBlock(), _createBlock(_component_notification_tile, _mergeProps({
                key: `notification-${index}`
              }, { ref_for: true }, notification, {
                class: "gfu-scrollable-item",
                role: "listitem",
                "data-qa": `spotlight-notification:${index}`
              }), null, 16 /* FULL_PROPS */, ["data-qa"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_ctx.canLoadMoreEvents)
              ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                  key: 0,
                  threshold: 0.5,
                  "root-margin": 400,
                  class: "_pl-1",
                  onLoadMore: $options.getNotifications
                }, null, 8 /* PROPS */, ["onLoadMore"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['_flex _fd-c--l', $options.wrapperClassList]),
            role: "list"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.placeholders, (placeholder) => {
              return (_openBlock(), _createBlock(_component_skeleton_notification, {
                key: placeholder,
                class: _normalizeClass($options.skeletonClassList),
                role: "listitem"
              }, null, 8 /* PROPS */, ["class"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["scroll-direction", "class"]))
}